<div class="user-card">
  <app-avatar [name]="name()" class="pointer" [title]="'user.settings' | transloco" />
  <div class="user-card__info">
    <span class="user-card__name body-sm-regular">{{ name() }}</span>
    <span class="user-card__role caption-regular">{{ role() }}</span>
  </div>
  <app-icon-button
    icon="icons/sidebar/settings_icon.svg"
    [size]="20"
    [label]="'user.settings' | transloco"
    (click)="settingsClick.emit()"
  >
  </app-icon-button>
</div>
